/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EditorialModule_editorialArticles = {
    readonly articles: ReadonlyArray<{
        readonly title: string;
        readonly imageUrl: {
            readonly thumb: string;
            readonly medium: string;
            readonly full: string;
        };
        readonly subtitle: string;
        readonly publishedDate: string;
        readonly link: string;
        readonly source: string;
    }> | null;
    readonly " $refType": "EditorialModule_editorialArticles";
};
export type EditorialModule_editorialArticles$data = EditorialModule_editorialArticles;
export type EditorialModule_editorialArticles$key = {
    readonly " $data"?: EditorialModule_editorialArticles$data;
    readonly " $fragmentRefs": FragmentRefs<"EditorialModule_editorialArticles">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "EditorialModule_editorialArticles",
  "type": "WordpressArticlesType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "articles",
      "storageKey": null,
      "args": null,
      "concreteType": "WordpressArticleType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "imageUrl",
          "storageKey": null,
          "args": null,
          "concreteType": "WordpressArticleImageType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "thumb",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "medium",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "full",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "subtitle",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "publishedDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "link",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "source",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '76389ed73f2b73da5594824c65476247';
export default node;
